import classNames from "classnames";
import React from "react";

import { InputFieldSetProps } from "../input_field_set";
import css from "../input_field_set.module.scss";

type ErrorProps = {
  className?: string;
  error: InputFieldSetProps["error"];
  warning: InputFieldSetProps["warning"];
};

export const Error = ({ className, error, warning }: ErrorProps) => {
  const content = error || warning;

  return (
    <div
      className={classNames({ [css.error]: error, [css.warning]: warning }, className)}
      data-target-id="input_field_set__error"
    >
      {Array.isArray(content) ? content.map((err) => <span key={err}>{err}</span>) : <span>{content}</span>}
    </div>
  );
};
